import React, {useEffect, useState} from 'react'
import { Link,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { PassedMonths,ChangeSimpleDateString, addThousandPoint, ChangeMobileFormat,GetStudyTime,
        GetSimpleDateTimeFromJDateTime,isNull,isObjEmpty,GetChildrenState,GetMonthDateString,
        remainDays,GetPaymentStatus} from "../../components/common/Common";

import calendarIcon from "../../img/icon/icon-view-calendar.svg";
import kidsIcon from "../../img/icon/icon-view-kids.svg";
import classIcon from"../../img/icon/icon-view-class.svg";
import sampleImage from "../../img/sample01.png";

//수업에 대한 원생 정보
const ChildrenInformation = () => {
  const { ch_idx,cl_idx } = useParams();
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //정보저장변수
  const [varMemberInfo,setMemberInfo] = useState({}); //원생정보
  const [varClassInfo,setClassInfo] = useState({});   //수업정보
  const [varPaymentInfo,setPaymentInfo] = useState({}); //결제정보
  const [varAttendanceList,setAttendanceList] = useState([]); //출석내역

  const [varRefundPayment,setRefundPayment] = useState(true); 

  //원생 수업상세정보 호출
  const GetClassInformation = async() => {
    const sendData = {ch_idx:ch_idx,cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_class_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //원생정보
        if(datas.results.length > 0) setMemberInfo(datas.results[0]);
        //원생별 수강정보
        if(datas.classInfo.length > 0) setClassInfo(datas.classInfo[0]);
        //원생별 결제정보
        if(datas.paymentInfo.length > 0) {
          const paymentInfo = datas.paymentInfo[0];
          setPaymentInfo(paymentInfo);
          //결제취소유무
          if(remainDays(paymentInfo.ph_pdate) > -7) {
            setRefundPayment(false);
          } 
        }
        //수업별 원생정보
        if(datas.studys.length > 0) setAttendanceList(datas.studys);
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetClassInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //결제취소 - 결제시스템
  const onCancelPaymentHandler = async(e) => {
    if(varPaymentInfo.ph_status === 5) return false;
    if(varRefundPayment && (varPaymentInfo.ph_status < 2 || varPaymentInfo.ph_status > 4)) return false;
    if(varRefundPayment) {
      let ph_status = 4;
      let sprompt = '환불 요청을 하시겠습니까?';
      if(varPaymentInfo.ph_status === 4){
        ph_status = 5;
        sprompt = '환불 완료 상태로 변경하시겠습니까?';
      } 
      if(!window.confirm(sprompt)) return false;
      const ph_idx = varPaymentInfo.ph_idx;

      const cl_idx = varPaymentInfo.ph_cl_idx;
      const ch_idx = varPaymentInfo.ph_ch_idx

      const sendData = {ph_idx:ph_idx,ph_status:ph_status,cl_idx:cl_idx,ch_idx:ch_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_update_payment_status`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        alert(datas.message);
        if(datas.retvalue === 1) {
          setPaymentInfo({...varPaymentInfo,ph_status:ph_status});
          if(ph_status === 5) GetClassInformation();
        }
      });
    } else {
      //원생의 학기내 등록한 수업 총수
      let smc_idx = 0;
      let smc_studys = 0;
      let smc_store = 0;
      if(!isNull(varMemberInfo.smc_idx)) smc_idx = varMemberInfo.smc_idx;
      if(!isNull(varMemberInfo.smc_studys)) smc_studys = varMemberInfo.smc_studys - varClassInfo.cl_studys;
      if(!isNull(varMemberInfo.smc_store)) smc_store = varMemberInfo.smc_store - varClassInfo.cl_studys;

      if(smc_studys < 0 || smc_idx === 0) {
        alert('원생의 수업차수가 등록되어 있지 않아 결제를 취소할 수 없습니다. 관리자에게 문의해주세요.'); return false;
      }
      //수업이 
      if(varClassInfo.ycount > 0) {
        alert('이미 수업이 진행되어 결제를 취소할 수 없습니다. 관리자에게 문의해주세요.'); return false;
      }

      if(!window.confirm('결제를 취소하시겠습니까?')) return false;

      let apiStrinhg = "branch_cancel_payment_gateway";
      //가맹점에서 결제한 경우
      if(varPaymentInfo.ph_who === 1) apiStrinhg = "branch_cancel_payment";

      const ph_idx = varPaymentInfo.ph_idx;
      const bill_id = varPaymentInfo.ivc_id;
      const price = varPaymentInfo.ph_price;
      const branch_member_id = localStorage.getItem("branch_member_id");
      const branch_merchant_id = localStorage.getItem("branch_merchant_id");
      const sendData = {ph_idx:ph_idx,cl_idx:varPaymentInfo.ph_cl_idx,ch_idx:varPaymentInfo.ph_ch_idx,
        branch_member_id:branch_member_id,branch_merchant_id:branch_merchant_id,
        bill_id:bill_id,price:price,smc_idx:smc_idx,smc_store:smc_store,smc_studys:smc_studys};
        
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/${apiStrinhg}`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        alert(datas.message);
        if(datas.retvalue === 1) {
          GetClassInformation();
        }
      });
    }
  }

  return (
    <div className="vh-content normal-wrap class-view-wrap">
      <HeaderBranchTitle varPageTitle={'수강 현황'} />
      <div className="vh-content-body">
        {/* 원생정보 */}
        <div className="class-info">
          <div className="class-left">
            <div className="name">{varMemberInfo.ch_name}</div>
            <div>{PassedMonths(varMemberInfo.ch_birthday)+"개월"} ({ChangeSimpleDateString(varMemberInfo.ch_birthday)}) ({GetChildrenState(varMemberInfo.ch_status)})</div>
          </div>
        </div>
        <div className="view-con">
          <div className="center-wrap">
             {/* 수업정보 */}
            <div className="con con01">
              <div className="img-box">
                <img src={sampleImage} alt=""/>
              </div>
              <div className="txt-box">
                <p className="class-tit">{varClassInfo.cl_name}</p>
                <div className="class-date flex">
                  <img src={calendarIcon} alt=""/>
                  <p>{ChangeSimpleDateString(varClassInfo.sm_sdate)} ~ {GetMonthDateString(varClassInfo.sm_edate)}</p>
                </div>
                <div className="class-kids flex">
                  <img src={kidsIcon} alt=""/>
                  <p>{varClassInfo.vl_name} ({varClassInfo.ch_attendance})</p>
                </div>
                <div className="class-state flex">
                  <img src={classIcon} alt=""/>
                  <p>수업 차수 {varClassInfo.ycount}/{varClassInfo.tcount} ˙ 출석 {varClassInfo.ecount} ˙ 결석 {varClassInfo.xcount}</p>
                </div>
              </div>
            </div>
            {/* 결제정보 */}
            <div className="con con02">
              <div className="con-tit">결제 현황
                <div className="con-state">
                  <span>{isObjEmpty(varPaymentInfo)?"미청구":GetPaymentStatus(varPaymentInfo.ph_status)}</span>
                  <span>{isObjEmpty(varPaymentInfo)?"":`₩ ${addThousandPoint(varPaymentInfo.ph_price)} 원`}</span>
                </div>
              </div>
              {isObjEmpty(varPaymentInfo)?null:
                <div className="con-box">
                  <ul>
                    <li>
                      <p>청구서 구분</p>
                      <div>{varPaymentInfo.cl_name}</div>
                    </li>
                    <li>
                      <p>수업 구분</p>
                      <div>{varPaymentInfo.cl_mode===1?"정규수업":"보강수업"}</div>
                    </li>
                    <li>
                      <p>학부모</p>
                      <div>{varPaymentInfo.mem_name} ({ChangeMobileFormat(varPaymentInfo.mem_mobile)})</div>
                    </li>
                    <li>
                      <p>청구서 ID</p>
                      <div>{varPaymentInfo.ivc_id}</div>
                    </li>
                    <li>
                      <p>결제 상태</p>
                      <div>{GetPaymentStatus(varPaymentInfo.ph_status)} {varPaymentInfo.ph_status!==2?null:"("+GetSimpleDateTimeFromJDateTime(varPaymentInfo.ph_pdate)+")"} </div>
                    </li>
                  </ul>
                  {(varPaymentInfo.ph_status<2 || varPaymentInfo.ph_status>5)?null:
                    <button className={(varPaymentInfo.ph_status>=2 && varPaymentInfo.ph_status<=4)?"btn-yes":"btn-no"} onClick={e=>onCancelPaymentHandler(e)}>
                      {!varRefundPayment && varPaymentInfo.ph_status===2?"결제 취소"
                      :(varPaymentInfo.ph_status===2 || varPaymentInfo.ph_status===3)?"환불요청"
                      :(varPaymentInfo.ph_status===4 || varPaymentInfo.ph_status===5)?"환불완료"
                      :null}
                    </button>
                  }
                </div>
              }
            </div>
            {/* 출결 현황 */}
            <div className="con con03">
                <div className="con-tit">출결 현황</div>
                <div className="con-box">
                  <ul style={{height:"auto"}}>
                    {varAttendanceList.map((attendance,j)=>(
                      <li key={'attendance_'+j}>
                        <p>{attendance.cs_index}차 수업</p>
                        <div>{attendance.cl_name} 
                            {isNull(attendance.csc_idx)?"수강없음"
                            :attendance.csc_status===-1?`추천 : ${GetStudyTime(attendance)}`
                            :attendance.csc_status===1?`예정 : ${GetStudyTime(attendance)}`
                            :attendance.csc_status===2?`출석 : ${GetSimpleDateTimeFromJDateTime(attendance.csc_rdate)}`
                            :`결석 : ${GetStudyTime(attendance)}`}
                          </div>
                      </li>
                    ))}
                  </ul>
                </div>
            </div>
          </div>
        </div>
        <div className="form-contoller bt-btn" style={{bottom:"10px"}}>
          <Link to={`/Branch/ToggleClassStudy/${ch_idx}/${cl_idx}`} className="form-contoller-btn btn-yes" style={{width:"100%"}}>
            {varClassInfo.clc_status===3?"수강 재개":"수강 정지"} 
          </Link>
        </div>
			</div>
    </div>
  )
}
export default ChildrenInformation;